import React from 'react'
import Employee from './components/Employee'
import Manager from './components/Manager'
import Executive from './components/Executive'

const Survey = () => {

  const [questions, setQuestions] = React.useState(
    JSON.parse(sessionStorage.getItem('survey-questions') || '[]')
  );
  const [currentIndex, setCurrentIndex] = React.useState(0);

  return (
    <div className='bg-white min-h-screen p-5 '>
        {/* <h1 className='text-lg font-semibold mb-5'>1. KEY ACHIEVEMENT EMPLOYEE</h1> */}
        <section className='grid grid-cols-1 gap-5 md:grid-cols-1'>
            <Employee questions={questions} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} />
            {/* <Manager />
            <Executive /> */}
        </section>
    </div>
  )
}

export default Survey